import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase, withValues} from 'utils/object';
import {request} from 'utils/request-axios';
import {DocumentConversionSettings} from './types';

type PossibleResponses =
    Api.Response.RedirectAxios<'settings_document_conversion_view'>;

const usePatchDocumentConversionSettings = (
    settingMid: string,
): UseMutationResult<PossibleResponses, Error, DocumentConversionSettings> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData: toSnakeCase(withValues(formData)),
            locale,
            method: 'PATCH',
            url: `/ui/document/conversion-settings/${settingMid}/`,
        }),
    );
};

export default usePatchDocumentConversionSettings;
